<template lang="pug">
  .type-slider(:class="color")
    h1(:class="sliderClass") {{ displayText }}
    .description
      h2.f-0.body
        | A typeface inspired by <a target="_blank" href="https://www.moma.org/calendar/exhibitions/5056?locale=en">The Redaction</a> by Titus Kaphar and Reginald Dwayne Betts
      h2.f-0.body.white
        a.venue(href="https://www.nxthvn.com/calendar/")
          | NXTHVN / August – September 26
    div.pre
      span(v-for="f in fonts" :class="f")
        span(v-for="w in weights" :class="[f, w]")
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: "FontSlider",
  data() {
    return {
      fonts: ["f-0", "f-1", "f-2", "f-3", "f-4", "f-5", "f-6"],
      weights: ["b", "i"]
    };
  },

  props: ["sliderClass", "color"],

  computed: {
    ...mapGetters({
      getMobile: 'getMobile'
    }),

    displayText() {
      return this.getMobile ? 'R' : 'redaction'
    }
  },

  methods: {
    ...mapActions({
      setMobile: 'setMobile'
    }),

    handleMobileBreakPoint(mql) {
      this.setMobile(mql.matches)
    }
  },

  mounted() {
    let mediaQueryList = window.matchMedia('(max-width: 768px)')
    mediaQueryList.addListener(this.handleMobileBreakPoint)
    this.handleMobileBreakPoint(mediaQueryList)
  }
}
</script>

<style lang="sass">
@import '@/styles/_variables.sass'
.type-slider
  height: 100vh
  width: 100vw
  position: relative
  cursor: none
  a
    font-style: italic
  h1
    width: 100%
    font-size: 65vw
    line-height: 1
    user-select: none
    text-align: center
    position: absolute
    top: 30%
    left: 0
    transform: translateY(-30%)
    @media only screen and (min-width: $m)
      font-size: 16vw
      top: 22.5rem
      top: 50%
      transform: translateY(-50%)
  .venue
    font-style: normal
  .description
    position: absolute
    bottom: 15vH
    left: 0
    width: 100%
    display: flex
    justify-content: center
    align-items: center
    flex-direction: column
    h2
      margin-bottom: 2rem
      padding: .1rem .75rem
      text-align: center
      @media only screen and (min-width: $m)
        text-align: left
  .pre
    opacity: 0
</style>
